import { ServiceException } from '@inter-ikea-kompis/exceptions';
import CookieUtility from '../../utilities/CookieUtility.js';
const COOKIE_NAME = 'ikeacn_cookie_consent';
const consentLevelMapping = {
    1: 'necessary',
    2: 'performance',
    3: 'functional',
    4: 'targeting'
};
/**
 * This class is used for checking cookie consent for the CN market.
 */
export default class ChinaCookieConsentService {
    /**
     * Checks if cookie consent meets a provided level.
     *
     * @param consentLevel Consent level (1-4).
     * @returns Promise of boolean.
     */
    async hasCookieConsent(consentLevel) {
        const cookie = CookieUtility.getCookie(COOKIE_NAME);
        if (cookie) {
            try {
                const consentCookie = JSON.parse(cookie);
                return !!consentCookie.level?.includes(consentLevelMapping[consentLevel]);
            }
            catch (error) {
                throw new ServiceException(`Failed to parse china cookie consent cookie. ${error}`);
            }
        }
        return false;
    }
}
//# sourceMappingURL=ChinaCookieConsentService.js.map